import { h, Component } from 'preact';
import HTML from 'components/core/html/html.js';
import copy from 'helpers/copy';
import { joinClasses, loadImage } from 'utils/utils';
import { Download, Prev, Next } from 'helpers/svgs';
import { getBlob } from 'helpers/index';
import slugify from 'utils/slugify';
import s from 'components/bolt/airport/popUpWindows/planet/planet.sss';
import Store from 'store/store';

export default class Planet extends Component {
	constructor(props) {
		super(props);
		this.gallery = this.props?.section?.planet?.gallery || [];
		if (this.gallery.length === 2) {
			this.gallery = [...this.gallery, ...this.gallery];
		}

		this.carouselWallpapers = this.props?.section.planet.wallpapers || [];
		if (this.carouselWallpapers.length === 3) {
			this.carouselWallpapers = [...this.carouselWallpapers, ...this.carouselWallpapers];
		}

		this.galleryOnPrevClick = this.galleryOnPrevClick.bind(this);
		this.galleryOnNextClick = this.galleryOnNextClick.bind(this);
		this.toggleGalleryExpand = this.toggleGalleryExpand.bind(this);
		this.onGalleryInteractionOverlayClick = this.onGalleryInteractionOverlayClick.bind(this);
		this.onPrevWallpaperClick = this.onPrevWallpaperClick.bind(this);
		this.onNextWallpaperClick = this.onNextWallpaperClick.bind(this);
		this.getDeviceSize = this.getDeviceSize.bind(this);

		this.state = {
			activegalleryIndex: 0,
			galleryExpanded: false,
			carouselFirstWallpaper: 0,
			wallpaperDownloadData: {}
		};
	}

	getDeviceSize() {
		const { client } = this.props;
		if (client.dimensions && client.dimensions.width > 1024 && client.dimensions && client.dimensions.height > 700) {
			return 'desktop';
		} else if (client.deviceSize === 'mobile' || client.dimensions && client.dimensions.height < 1000) {
			return 'mobile';
		} 
		return 'tablet';
	}

	onGalleryInteractionOverlayClick() {
		const { galleryExpanded } = this.state;
		const { client } = this.props;
		if (!client.isDesktopWidth) return;
		if (galleryExpanded) return;

		this.toggleGalleryExpand();
	}

	galleryOnPrevClick() {
		const { prevIndex } = this.getGalleryIndexPositions();
		this.setState({ activegalleryIndex: prevIndex });
	}

	galleryOnNextClick() {
		const { nextIndex } = this.getGalleryIndexPositions();
		this.setState({ activegalleryIndex: nextIndex });
	}

	onPrevWallpaperClick() {
		const { prevIndex } = this.getCarouselWallpaperPositions();
		this.setState({ carouselFirstWallpaper: prevIndex });
	}

	onNextWallpaperClick() {
		const { carouselSecondWallpaper } = this.getCarouselWallpaperPositions();
		this.setState({ carouselFirstWallpaper: carouselSecondWallpaper });
	}

	getGalleryIndexPositions() {
		const { activegalleryIndex } = this.state;

		const prevIndex = activegalleryIndex === 0 ? this.gallery.length - 1 : activegalleryIndex - 1;
		const nextIndex = activegalleryIndex + 1 >= this.gallery.length ? 0 : activegalleryIndex + 1;

		return { prevIndex, activegalleryIndex, nextIndex };
	}

	getCarouselWallpaperPositions() {
		const { carouselFirstWallpaper } = this.state;

		const carouselSecondWallpaper = carouselFirstWallpaper + 1 >= this.carouselWallpapers.length ? 0 : carouselFirstWallpaper + 1;
		const nextIndex = carouselSecondWallpaper + 1 >= this.carouselWallpapers.length ? 0 : carouselSecondWallpaper + 1;
		const prevIndex = carouselFirstWallpaper === 0 ? this.carouselWallpapers.length - 1 : carouselFirstWallpaper - 1;

		return { prevIndex, carouselFirstWallpaper, carouselSecondWallpaper, nextIndex };
	}

	toggleGalleryExpand(e) {
		e?.stopPropagation();
		this.setState({ galleryExpanded: !this.state.galleryExpanded });
	}

	async downloadWallpaper(wallpaper, type, wallpaperSectionIndex) {
		const { wallpaperDownloadData } = this.state;
		const { section, imageRoot, assetFolder, client } = this.props;
		const filename = slugify(`${section.name}-${wallpaper[type]}`).replace('-jpg', '').replace('-png', '');

		const wallpaperNum = wallpaperSectionIndex % this.props?.section.planet.wallpapers.length;
		Store.emit('CUSTOM_EVENT', {
			category: 'planet-overlay',
			action: 'wallpaper-download',
			label: `${section.id}_${wallpaperNum}_${type}`
		});
		
		let shareData;
		let dataUrl;

		if (wallpaperDownloadData?.[filename]) {
			shareData = wallpaperDownloadData[filename].shareData;
			dataUrl = wallpaperDownloadData[filename].dataUrl;
		} else {
			this.setState({
				[`showLoading${wallpaperSectionIndex}${type}`]: true
			});
			const wallpaperImg = await loadImage(`${imageRoot}/airport/destinations/${assetFolder}/wallpapers/${wallpaper[type]}?_cors=1`);
			const c = document.createElement('canvas');
			const context = c.getContext('2d');
			c.width = wallpaperImg.naturalWidth;
			c.height = wallpaperImg.naturalHeight;
			context.drawImage(wallpaperImg, 0, 0);

			const imgBlob = await getBlob(c);
			const files = [
				new File([imgBlob], `${filename}.jpeg`, { type: 'image/jpeg' })
			];
			shareData = {
				files
			};
			dataUrl = c.toDataURL('image/jpeg');
			this.setState({
				wallpaperDownloadData: {
					...wallpaperDownloadData,
					[filename]: { shareData, dataUrl }
				},
				[`showLoading${wallpaperSectionIndex}${type}`]: false
			});
		}
		
		const canShare = navigator.canShare && navigator.canShare(shareData);
		
		if (!canShare || client?.device === 'desktop') {
			const link = document.createElement('a');
			link.download = filename;
			link.href = dataUrl;
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			return;
		}
		navigator.share(shareData);
	}


	renderPlanetImage() {
		const { imageRoot, assetFolder } = this.props;
		return <img class={s.planetImage} src={`${imageRoot}/airport/destinations/${assetFolder}/lmhio2.webp`} />;
	}

	renderDescription() {
		const { section } = this.props;

		const descriptionCopy = section?.planet?.copy?.description;

		return (
			<div class={s.descriptionContainer}>
				<HTML class={s.description} content={descriptionCopy} markdown />
			</div>
		);
	}

	renderGallery() {
		const { section, imageRoot, assetFolder, client } = this.props;
		const { galleryExpanded } = this.state;
		const { prevIndex, activegalleryIndex, nextIndex } = this.getGalleryIndexPositions();

		const deviceSize = this.getDeviceSize();
		return (
			<div class={joinClasses(s.galleryContainer, galleryExpanded && s.expanded, section.id && s[section.id])}>
				<div class={joinClasses(s.imageContainer)}>
					{this.gallery.map((image, i) => (
						<img
							class={joinClasses(
								s.galleryImage,
								activegalleryIndex === i && s.activeImage,
								prevIndex === i && s.prevImage,
								nextIndex === i && s.nextImage
							)}
							key={`${section.id}-gallery-${i}`}
							src={`${imageRoot}/airport/destinations/${assetFolder}/gallery/${image}`}
						/>
					))}
					<div class={s.galleryInteractionOverlay} onClick={this.onGalleryInteractionOverlayClick}>
						<button
							class={s.galleryExpandBtn}
							onClick={this.toggleGalleryExpand}
						>
							<img src={`${imageRoot}/airport/f7o5dh.webp`} />
						</button>
						<button
							class={s.galleryContractBtn}
							onClick={this.toggleGalleryExpand}
						>
							<img src={`${imageRoot}/airport/f7o5dh-a.webp`} />
						</button>
					</div>
				</div>
				{deviceSize == 'mobile' && this.renderPlanetImage()}
				{this.gallery.length > 1 && (
					<div class={s.galleryNavBtns}>
						<button
							class={s.galleryNavBtn}
							onClick={this.galleryOnPrevClick}
						>
							<img src={`${imageRoot}/airport/back.webp`} />
						</button>
						<button
							class={s.galleryNavBtn}
							onClick={this.galleryOnNextClick}
						>
							<img src={`${imageRoot}/airport/next.webp`} />
						</button>
					</div>
				)}
			</div>
		);
	}

	renderWallpapers() {
		const { section, imageRoot, assetFolder } = this.props;
		const wallpapers = this.carouselWallpapers;
		const { prevIndex, carouselFirstWallpaper, carouselSecondWallpaper, nextIndex } = this.getCarouselWallpaperPositions();

		let showArrows = wallpapers.length > (this.getDeviceSize() == 'mobile' ? 1 : 2);
		const deviceSize = this.getDeviceSize() == 'tablet' ? 'desktop' : this.getDeviceSize();

		return (
			<div class={s.wallpaperContainer}>
				<p class={s.wallpaperHeading}>{copy.$planetOverlays.wallpapers}:</p>
				<div class={s.wallpaperCarousel}>
					{wallpapers.map((wallpaper, i) => (
						<div 
							class={
								joinClasses(
									s.wallpaperSection,
									i === prevIndex && s.prevWallpaper,
									i === carouselFirstWallpaper && s.firstWallpaper,
									i === carouselSecondWallpaper && s.secondWallpaper,
									i === nextIndex && s.nextWallpaper
								)
							}
							key={`${section.id}-wallpaper-${i}`}
						>
							<div class={s.wallpaperPreview}>
								<img src={`${imageRoot}/airport/destinations/${assetFolder}/wallpapers/thumbnails/${deviceSize}/${wallpaper.preview}`} />
							</div>
							<div class={s.wallpaperDownloadBtns}>
								<button
									class={joinClasses(s.wallpaperDownloadBtn, this.state[`showLoading${i}mobileDownload`] && s.loading)}
									onClick={() => this.downloadWallpaper(wallpaper, 'mobileDownload', i)}
								>
									<span>{copy.$planetOverlays.mobile}</span>
									<Download class={s.downloadIcon} />
								</button>
								<button
									class={joinClasses(s.wallpaperDownloadBtn, this.state[`showLoading${i}desktopDownload`] && s.loading)}
									onClick={() => this.downloadWallpaper(wallpaper, 'desktopDownload', i)}
								>
									<span>{copy.$planetOverlays.desktop}</span>
									<Download class={s.downloadIcon} />
								</button>
							</div>
						</div>
					))}
				</div>
				{showArrows && (
					<div class={s.wallpaperCarouselNav}>
						<button class={s.wallpaperCarouselNavBtn} onClick={this.onPrevWallpaperClick}>
							<img src={`${imageRoot}/airport/back.webp`} />
						</button>
						<button class={s.wallpaperCarouselNavBtn} onClick={this.onNextWallpaperClick}>
							<img src={`${imageRoot}/airport/next.webp`} />
						</button>
					</div>
				)}
			</div>
		);


	}

	renderInfo() {
		const { section } = this.props;
		const planetCopy = section?.planet?.copy || {};
		const infoSections = ['conditions', 'seasonalOutlook', 'notice'];

		return (
			<div class={s.infoContainer}>
				{infoSections.map((info) => (
					<div class={s.infoSection} key={`${section.id}-${info}`}>
						<h4 class={s.infoTitle}>{copy.$planetOverlays[info] + ':'}</h4>
						<HTML
							class={s.infoText}
							content={planetCopy[info]}
							markdown
						/>
					</div>
				))}
			</div>
		);

	}

	renderMobile() {
		const { section } = this.props;
		return (
			<div class={s.scroller}>
				<div class={joinClasses(s.content, s[section.id])}>
					{this.renderGallery()}
					{this.renderDescription()}
					{this.renderInfo()}
					{this.renderWallpapers()}
				</div>
			</div>
		);
	}

	renderTablet() {
		const { section } = this.props;
		return (
			<div
				class={joinClasses(s.content, s[section.id])}
				onMouseDown={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>
				{this.renderGallery()}
				{this.renderPlanetImage()}	
				<div class={s.bottomHalf}>
					<div class={s.leftColumn}>
						{this.renderDescription()}
						{this.renderWallpapers()}
					</div>
					{this.renderInfo()}
				</div>
			</div>
		);
	}

	renderDesktop() {
		const { section } = this.props;
		return (
			<div
				class={joinClasses(s.content, s[section.id])}
				onMouseDown={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>
				<div class={s.topHalf}>
					<div class={joinClasses(s.gallerySpace, section.id && s[section.id])} />
					<div class={s.rightColumn}>
						{this.renderDescription()}
						{this.renderWallpapers()}
					</div>
				</div>
				{this.renderInfo()}
				{this.renderGallery()}
				{this.renderPlanetImage()}
			</div>
		);
	}

	render () {
		const deviceSize = this.getDeviceSize();
		if (deviceSize === 'desktop') {
			return this.renderDesktop();
		} else if (deviceSize === 'mobile') {
			return this.renderMobile();
		} 
		return this.renderTablet();
	}
}